import { render } from "./FileViewer.vue?vue&type=template&id=6d3e9c26&ts=true"
import script from "./FileViewer.vue?vue&type=script&lang=ts"
export * from "./FileViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__